import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useParams, useNavigate } from 'react-router-dom';
import { CreditCard, Building2, Lock, Upload, FileText } from 'lucide-react';
export function PaymentLinkPage() {
  const {
    paymentLinkId
  } = useParams();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const handlePay = (e: React.FormEvent) => {
    e.preventDefault();
    setIsProcessing(true);
    setTimeout(() => {
      navigate(`/pay/${paymentLinkId}/success`);
    }, 1500);
  };
  return <div className="min-h-screen bg-background text-textMain py-12 px-6" data-id="element-6779">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6780">
        {/* Left: Summary */}
        <div data-id="element-6781">
          <div className="mb-8" data-id="element-6782">
            <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center text-primary text-xl font-bold mb-4" data-id="element-6783">
              TW
            </div>
            <h1 className="text-2xl font-bold mb-1" data-id="element-6784">Deposit Payment</h1>
            <p className="text-textMuted" data-id="element-6785">The Wildwoods</p>
          </div>

          <div className="bg-surface border border-border rounded-xl p-6 mb-6" data-id="element-6786">
            <div className="text-sm text-textMuted mb-1" data-id="element-6787">Amount Due</div>
            <div className="text-4xl font-bold mb-6" data-id="element-6788">$750.00</div>

            <div className="space-y-3 text-sm" data-id="element-6789">
              <div className="flex justify-between border-b border-border pb-3" data-id="element-6790">
                <span className="text-textMuted" data-id="element-6791">For</span>
                <span className="font-medium" data-id="element-6792">Jun 12 Show Deposit</span>
              </div>
              <div className="flex justify-between border-b border-border pb-3" data-id="element-6793">
                <span className="text-textMuted" data-id="element-6794">Invoice</span>
                <span className="font-medium" data-id="element-6795">INV-2026-041</span>
              </div>
              <div className="flex justify-between pb-1" data-id="element-6796">
                <span className="text-textMuted" data-id="element-6797">Due Date</span>
                <span className="font-medium" data-id="element-6798">Jun 1, 2026</span>
              </div>
            </div>
          </div>

          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-6799">
            <h3 className="font-semibold mb-2 text-sm" data-id="element-6800">Paid off-platform?</h3>
            <p className="text-xs text-textMuted mb-4" data-id="element-6801">
              If you paid via wire transfer or check, upload your receipt here.
            </p>
            <button className="w-full py-2 bg-background border border-border rounded-lg text-sm font-medium hover:border-primary transition-colors flex items-center justify-center gap-2" data-id="element-6802">
              <Upload className="w-4 h-4" data-id="element-6803" /> Upload Receipt
            </button>
          </div>
        </div>

        {/* Right: Payment Form */}
        <div className="bg-surface border border-border rounded-2xl p-6 md:p-8" data-id="element-6804">
          <h2 className="text-xl font-bold mb-6" data-id="element-6805">Payment Details</h2>

          <form onSubmit={handlePay} className="space-y-6" data-id="element-6806">
            <div className="space-y-4" data-id="element-6807">
              <div data-id="element-6808">
                <label className="block text-sm font-medium mb-2" data-id="element-6809">
                  Card Information
                </label>
                <div className="relative" data-id="element-6810">
                  <CreditCard className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textMuted" data-id="element-6811" />
                  <input required type="text" placeholder="Card number" className="w-full pl-10 pr-4 py-3 bg-background border border-border rounded-t-lg text-sm focus:outline-none focus:border-primary" data-id="element-6812" />
                </div>
                <div className="flex" data-id="element-6813">
                  <input required type="text" placeholder="MM / YY" className="w-1/2 px-4 py-3 bg-background border border-border border-t-0 rounded-bl-lg text-sm focus:outline-none focus:border-primary" data-id="element-6814" />
                  <input required type="text" placeholder="CVC" className="w-1/2 px-4 py-3 bg-background border border-border border-t-0 border-l-0 rounded-br-lg text-sm focus:outline-none focus:border-primary" data-id="element-6815" />
                </div>
              </div>

              <div data-id="element-6816">
                <label className="block text-sm font-medium mb-2" data-id="element-6817">
                  Name on Card
                </label>
                <input required type="text" className="w-full px-4 py-3 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6818" />
              </div>
            </div>

            <button type="submit" disabled={isProcessing} className="w-full py-3.5 bg-primary text-background rounded-xl font-medium hover:bg-primaryHover transition-colors flex items-center justify-center gap-2 disabled:opacity-70" data-id="element-6819">
              {isProcessing ? 'Processing...' : `Pay $750.00`}
            </button>

            <div className="flex items-center justify-center gap-2 text-xs text-textMuted mt-4" data-id="element-6820">
              <Lock className="w-3 h-3" data-id="element-6821" /> Payments are secure and encrypted
            </div>
          </form>
        </div>
      </motion.div>
    </div>;
}